import { ReactNode } from 'react';

export const renderErrorMessage = (message: string | string[]): ReactNode => {
  if (!Array.isArray(message)) {
    return message;
  }

  if (message.length <= 1) {
    return message[0] ?? '';
  }

  return (
    <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
      {message.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
};
